import { CircularProgress, Container, Grid } from "@mui/material";
import React, { useEffect, useRef } from "react";

function LoadingResult({ isLoading }) {


  return (
    <div>
      {isLoading && (
        <Container
          style={{
            backgroundColor: "white",
            borderRadius: "7px",
            padding: "20px",
            marginBottom: "20px",
          }}
        >
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justify="center"
          >
            <Grid item xs={3} sx={{ mb: 2 }}>
              <CircularProgress color="success" />
            </Grid>
            <h3>Loading function...</h3>
          </Grid>
        </Container>
      )}
    </div>
  );
}

export default LoadingResult;
